import { defaultProducts } from 'helpers/transformHelpers';
import { getDefaultFormValues } from '../../../Recommendations/Recommendation/helpers/dataMappers';
import { mapProperties } from './convertPlanDataHelper';

export const mapPlanToRec = (
  user,
  plan,
  productsToInclude,
  propertyLandingPageData,
  fieldsAndAreasGeoJSONCollection
) => {
  const newRec = getDefaultFormValues(user);
  const products = productsToInclude.map(product => defaultProducts(product));

  newRec.products = products;
  newRec.properties =
    mapProperties(
      plan.cropZones,
      propertyLandingPageData,
      fieldsAndAreasGeoJSONCollection,
      plan
    ) || [];

  const totalApplied = plan.cropZones.reduce((ta, { areaValue }) => {
    return ta + areaValue;
  }, 0);

  newRec.totalApplied = totalApplied;
  newRec.cropSeasonIds = plan.cropSeasonIds.reduce((ids, currId) => {
    return `${ids}, ${currId}`;
  });
  newRec.source = [{ id: plan.id, name: plan.name }];

  // mapPlanToRec never carried these over, unlike the shared
  // CreateOperationFromPlan pipeline Work Order/Application conversion uses
  // (convertPlanToOperationFormikData's tagIds/notes) — a real omission,
  // not a UI-side read issue.
  newRec.notes = plan.notes;
  newRec.flagIds = plan.flagIds;

  return newRec;
};

export default mapPlanToRec;
